import { Enum } from '@loandolphin/dolphin-framework';

export default Enum;
